import React, { useEffect } from "react";
import { CDKGlobalHeader } from "@cdk-uip/react-global-header";
import "./Error.css"

const Error = props => {

    useEffect(() => {
        document.body.style.backgroundColor = '#fff';
    });

    return (
        <div className={'error'}>
            <CDKGlobalHeader appName="OnePay" />
            <div className={'error-status'}>{props.errorText}</div>
            <div className={'error-description'}>{props.errorDescription}</div>
        </div>
    );

};

export default Error;